const AnchorTag = ({ text }) => {
	const getUrlRedirect = (type: string) => {
		switch (type) {
			case 'PEPPER':
				return 'https://x.com/search?q=%24PEPPER&src=cashtag_click'
			case 'Governance':
				return 'https://governance.chilizchain.com/staking'
			case 'CHZ':
				return 'https://x.com/search?q=%24CHZ&src=cashtag_click'
			case 'Nansen.ai':
				return 'https://www.nansen.ai/'
			case 'Pepper':
				return 'https://x.com/PepperChain'
			default:
				break
		}
	}

	return (
		<a href={getUrlRedirect(text)} target="_blank" className="underline">
			{text}
		</a>
	)
}

export default AnchorTag
